import { MaterialService } from './material.service';
import { AchievementDoneList } from './../model/achievementDoneList.model';
import { AchievementDone } from './../model/achievementDone.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { KiwixiService } from '../kiwixi/kiwixi.service';
import { KiwixiGlobals } from '../kiwixi/kiwixi.globals';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AchievementManagerService } from './achievementManager.service';


@Injectable()
export class AchievementDoneservice extends AchievementManagerService {

    apiAchievementDone = environment.server + 'achievements_done/';


    constructor(
        private _http: HttpClient,
        private _router: Router,
        kiwixiGlobals: KiwixiGlobals,
        private materialService: MaterialService,) {
        super(_http, _router, kiwixiGlobals, materialService);
    }


    getAchievementDoneById(_id): Observable<AchievementDone> {
        const url = this.apiAchievementDone + _id + '/';
        return this.getAchievementDoneByUrl(url);
    }

    getAchievementDoneByUrl(_url): Observable<AchievementDone> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<AchievementDone>(_url, {
            headers: header
        })
            .pipe(
                catchError(this.handleErrorObservable<any>(`getAchievementDone`))
            );
    }

    getAchievementDones(params: HttpParams): Observable<AchievementDoneList> {
        const header = this.createHttpClientAuthorizationHeader();
        return this._http.get<AchievementDoneList>(this.apiAchievementDone, {
            headers: header,
            params: params
        })
            .pipe(
                map(_AchievementDones => _AchievementDones),
                catchError(this.handleErrorObservable<AchievementDoneList>(`getObservableAchievementDones`))
            );
    }
    patchFile(AchievementDoneUrl, param, field, file): Promise<AchievementDone> {
        const self = this;
        const headers = this.createHttpClientAuthorizationHeaderNoEnctype();
        const _formData = new FormData();
        _formData.append('enctype', 'multipart/form-data');
        self.headers.delete('Content-Type');
        _formData.append(field, file);
        _formData.append('name', file.name);
        return this._http.patch(AchievementDoneUrl, _formData, { headers: headers })
            .toPromise()
            .then((res: any) => res)
    }

    postAchievementDone(params) {
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.post<AchievementDone>(this.apiAchievementDone, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<AchievementDone>(`Création d'une fiche`)),
            );
    }

    patchAchievementDone(_id, params) {
        const url = this.apiAchievementDone + _id + '/';
        const headers = this.createHttpClientAuthorizationHeader();
        return this._http.patch<AchievementDone>(url, params, { headers: headers })
            .pipe(
                catchError(this.handleErrorObservable<AchievementDone>(`Création d'une fiche`)),
            );
    }
}
